import React, { useState } from 'react';
import '../Styles/ProjectCard.css';
import { ProjectCard } from '../Components/ProjectCard';
import { Lightbox } from '../Components/Lightbox';

export function ProjectSection() {
	const [lightboxContent, setLightboxContent] = useState(null);

	const projects = [
		{
			id: 'mocap',
			image: "/Images/AnimationsMocapThumbnail.png",
			videoUrl: "https://www.youtube.com/embed/RuI-Q_Qwpcs?si=XM4EUkZaivTI61Bn",
			buttonText: "Play on Roblox.com",
			buttonLink: "https://www.roblox.com/games/3093229294/Animations-Mocap",
			data: [
				{ type: 'title', content: 'Animations: Mocap' },
				{ type: 'divider', content: '———' },
				{ type: 'text', content: 'UI/UX Design, Programming' },
				{ type: 'divider', content: '———' },
				{ type: 'text', content: '330.5 Million Plays' },
				{ type: 'divider', content: '———' },
			]
		},
		{
			id: 'blank_construct',
			image: "/Images/BlankConstructThumbnail.png",
			videoUrl: "https://www.youtube.com/embed/OFbtTHau7v4?si=QEj6BW_UgnzxiH7P",
			buttonText: "Play on Itch.io",
			buttonLink: "https://gd50-studios.itch.io/blank-construct",
			data: [
				{ type: 'title', content: 'Blank Construct' },
				{ type: 'divider', content: '———' },
				{ type: 'text', content: 'UI/UX Design, Programming' },
				{ type: 'divider', content: '———' },
				{ type: 'text', content: 'Final Year University Project' },
				{ type: 'divider', content: '———' },
			]
		},
		{
			id: 'crusader_lads',
			image: "/Images/CrusaderLadsThumbnail.png",
			videoUrl: "https://www.youtube.com/embed/XVQl69l3glQ?si=pdBtko4LH9TFLFyR",
			buttonText: "Play on Itch.io",
			buttonLink: "https://grumtom.itch.io/crusader-lads",
			data: [
				{ type: 'title', content: 'Crusader Lads' },
				{ type: 'divider', content: '———' },
				{ type: 'text', content: 'Programming' },
				{ type: 'divider', content: '———' },
				{ type: 'text', content: '2nd Year University Project' },
				{ type: 'divider', content: '———' },
			]
		}
	];

	return (
		<>
			<div className="projects-section">
				{projects.map((project, index) => (
					<ProjectCard
					key={project.id}
					items={project.data} 
					image={project.image}
					videoUrl={project.videoUrl}
					buttonText={project.buttonText}
					buttonLink={project.buttonLink}
					imagePosition={index % 2 === 0 ? 'right' : 'left'}
					onOpen={(content) => setLightboxContent(content)}
			/>
				))}

				{lightboxContent && (
					<Lightbox 
						images={[lightboxContent]}
						currentIndex={0}
						onClose={() => setLightboxContent(null)}
						onNext={() => {}}
						onPrev={() => {}}
					/>
				)}
			</div>
			<div className="project-section-bottom">And finally, this website.</div>
		</>
	);
}